import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip
} from '@mui/material';
import { getAllRefundConvinceType, addOrUpdateConvinceType } from 'src/store/slices/dynamicCatalogSlice';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import {
  ORANGE,
  darkButtonSx,
  dialogPaperProps,
  inputSx,
  lightButtonSx,
  statusChipSx,
  useDynamicStyles
} from 'src/components/dynamicCatalogStyles';
import DynamicListToolbar, { filterDynamicRows } from 'src/components/DynamicListToolbar';

function ConvinceTypeDynamic() {
  const classes = useDynamicStyles();
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [convinceData, setConvienceData] = React.useState([]);
  const [updatePopUp, setUpdatePopUp] = React.useState(false);
  const [isConvinceTypeUpdate, setIsConvinceTypeUpdate] = React.useState(false);
  const [addOrUpdateConvinceActive, setAddOrUpdateConvinceActive] = React.useState(true);
  const [addOrUpdateConvinceId, setaddOrUpdateConvinceId] = React.useState("");
  const [addOrUpdateConvince, setAddOrUpdateConvince] = React.useState("");
  const [selectedConvinceType, setSelectedConvinceType] = React.useState([]);
  const [searchText, setSearchText] = React.useState('');
  const [statusFilter, setStatusFilter] = React.useState('all');

  const loadConvinceTypes = () => {
    setLoading(true);
    dispatch(getAllRefundConvinceType()).then(response => {
      if (response.payload?.length > 0) {
        setConvienceData(response.payload)
      }
      setLoading(false);
    })
  };

  useEffect(() => {
    loadConvinceTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  function updateConvinceTypeClick(row) {
    setIsConvinceTypeUpdate(true);
    setaddOrUpdateConvinceId(row.ID);
    setAddOrUpdateConvince(row.IKNA_TURU);
    setAddOrUpdateConvinceActive(row.AKTIF);
    setSelectedConvinceType(row);
    setUpdatePopUp(true);
  }

  function clearAddOrUpdateConvince() {
    setaddOrUpdateConvinceId("");
    setAddOrUpdateConvince("");
    setAddOrUpdateConvinceActive(true);
  }

  const addConvinceClick = () => {
    setIsConvinceTypeUpdate(false);
    clearAddOrUpdateConvince();
    setUpdatePopUp(true);
  }

  function closePopUp() {
    if (saving) return;
    setUpdatePopUp(false);
  }

  function addOrUpdateConvinceTypeClick() {
    var ConvinceId = addOrUpdateConvinceId.toString();
    var ConvinceType = addOrUpdateConvince.toString();
    var Active = addOrUpdateConvinceActive;

    let Reasondata = {
      ConvinceId: ConvinceId,
      ConvinceType: ConvinceType,
      Active: Active
    };

    setSaving(true);
    dispatch(addOrUpdateConvinceType(Reasondata)).then(() => {
      setSaving(false);
      setUpdatePopUp(false);
      clearAddOrUpdateConvince();
      loadConvinceTypes();
    })
  }

  const rowCount = convinceData?.length || 0;
  const activeCount = (convinceData || []).filter((r) => r.AKTIF === true).length;
  const filteredRows = useMemo(() => filterDynamicRows(convinceData, {
    searchText,
    statusFilter,
    searchFields: ['IKNA_TURU'],
    isActive: (r) => r.AKTIF === true
  }), [convinceData, searchText, statusFilter]);
  const convinceEmpty = !addOrUpdateConvince?.toString().trim();

  return (
    <>
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title="İkna Türleri"
          subheader={loading ? 'Yükleniyor…' : `${rowCount} kayıt · ${activeCount} aktif · ${rowCount - activeCount} pasif`}
          action={
            <Button startIcon={<AddIcon />} sx={darkButtonSx} onClick={addConvinceClick}>
              Yeni İkna Türü
            </Button>
          }
        />
        {loading && <LinearProgress sx={{ height: 2, '& .MuiLinearProgress-bar': { backgroundColor: ORANGE }, backgroundColor: '#ffe0b2' }} />}
        <DynamicListToolbar
          searchText={searchText}
          onSearchChange={setSearchText}
          placeholder="İkna türü ara"
          statusFilter={statusFilter}
          onStatusFilterChange={setStatusFilter}
          shownCount={filteredRows.length}
        />
        <TableContainer sx={{ maxHeight: 520 }}>
          <Table stickyHeader size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell align="left">İkna Türü</TableCell>
                <TableCell align="center" sx={{ width: 120 }}>Durum</TableCell>
                <TableCell align="center" sx={{ width: 90 }}>İşlem</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.map((row) => (
                <TableRow key={row.ID}>
                  <TableCell align="left">{row.IKNA_TURU}</TableCell>
                  <TableCell align="center">
                    <Chip size="small" label={row.AKTIF === true ? 'Aktif' : 'Pasif'} sx={statusChipSx(row.AKTIF === true)} />
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Düzenle">
                      <IconButton size="small" onClick={() => updateConvinceTypeClick(row)}>
                        <EditIcon sx={{ fontSize: 18, color: ORANGE }} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
              {!loading && filteredRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} className={classes.emptyState}>
                    {rowCount === 0 ? 'Kayıtlı ikna türü bulunamadı.' : 'Aramaya uygun kayıt bulunamadı.'}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Dialog
        open={updatePopUp}
        onClose={closePopUp}
        fullWidth
        maxWidth="sm"
        PaperProps={dialogPaperProps}
      >
        <DialogTitle className={classes.dialogTitle}>
          {isConvinceTypeUpdate ? 'İkna Türü Düzenle' : 'Yeni İkna Türü'}
          <IconButton size="small" onClick={closePopUp} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important', opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto', transition: 'opacity 0.2s' }}>
          <TextField
            label="İkna Türü"
            fullWidth
            multiline
            minRows={2}
            maxRows={4}
            size="small"
            sx={inputSx}
            onChange={(e) => setAddOrUpdateConvince(e.target.value)}
            value={addOrUpdateConvince}
          />
          <Box className={classes.dialogSection} sx={{ mt: 2 }}>
            <div className={classes.sectionLabel}>Durum</div>
            <ToggleButtonGroup
              exclusive
              size="small"
              className={classes.toggleGroup}
              value={addOrUpdateConvinceActive}
              onChange={(e, v) => v !== null && setAddOrUpdateConvinceActive(v)}
            >
              <ToggleButton value={true}>Aktif</ToggleButton>
              <ToggleButton value={false}>Pasif</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={closePopUp} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 110 }}
            onClick={addOrUpdateConvinceTypeClick}
            disabled={saving || convinceEmpty}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : null}
          >
            {isConvinceTypeUpdate ? 'Güncelle' : 'Ekle'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConvinceTypeDynamic;
